<div>
    <label (click)="isCollapsed = !isCollapsed"
           [attr.aria-expanded]="!isCollapsed" aria-controls="collapseSearchFilter">
        <i [ngClass]="isCollapsed?'fa fa-caret-right fa-2':'fa fa-caret-down fa-2'" aria-hidden="true"> </i>
        <strong class="d-inline-flex p-2">{{sectionLabel | translate}}</strong>
    </label>
    <div id="collapseSearchFilter" [ngbCollapse]="isCollapsed">
        <div class="card">
            <div class="card-body">
                <form class="d-flex align-items-center mb-2">
                    <div class="row">
                        <label class="col-auto" for="dropdownFilters" >{{filterDropdownLabel | translate}}</label>
                        <div class="col-auto mb-3">
                            <div class="input-group">
                                <select class="form-select" id="dropdownFilters" name="dropdownFilters"
                                        [(ngModel)]="selectedFilter" [disabled]="!hasFiltersAvailable()">
                                    <option value="" jhiTranslate="global.please.choose">Please Choose</option>
                                    <ng-container *ngFor="let filter of filters">
                                        <option [value]="filter.key" *ngIf="!filter.added && !filter.default">
                                            <label>{{filter.name | translate}}</label>
                                        </option>
                                    </ng-container>
                                </select>
                                <button class="btn btn-info float-end" (click)="AddFilter()" [disabled]="!hasFiltersAvailable()" data-test="addFilterButton">
                                    <i class="fa fa-plus"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="mb-2">
                    <div *ngFor="let filter of filtersAdded">
                        <div class="column-filter-badge">
                            <ng-template #popover>
                                <jhi-column-filter-number *ngIf="filter.type === FILTER_TYPES.NUMBER"
                                                          [filter]="filter"
                                                          (onApply)="updateFilter(filter)"
                                                          (onReset)="reset(filter)">
                                </jhi-column-filter-number>
                                <jhi-column-filter-date *ngIf="filter.type === FILTER_TYPES.DATE"
                                                        [filter]="filter"
                                                        (onApply)="updateFilter(filter)"
                                                        (onReset)="reset(filter)">
                                </jhi-column-filter-date>
                                <jhi-column-filter-number-range *ngIf="filter.type === FILTER_TYPES.NUMBER_RANGE"
                                                                [filter]="filter"
                                                                (onApply)="updateFilter(filter)"
                                                                (onReset)="reset(filter)">
                                </jhi-column-filter-number-range>
                                <jhi-column-filter-checklist *ngIf="filter.type === FILTER_TYPES.CHECKLIST"
                                                             [filter]="filter"
                                                             (onApply)="updateCheckListFilter(filter, filter.key)"
                                                             (onReset)="reset(filter)">
                                </jhi-column-filter-checklist>
                                <jhi-column-filter-text *ngIf="filter.type === FILTER_TYPES.TEXT"
                                                        [filter]="filter"
                                                        (onApply)="updateTextFilter(filter, filter.key)"
                                                        (onReset)="reset(filter)">
                                </jhi-column-filter-text>
                                <jhi-column-filter-radio *ngIf="filter.type === FILTER_TYPES.RADIOBUTTON"
                                                         [filter]="filter"
                                                         (onApply)="updateRadioFilter(filter, filter.key)"
                                                         (onReset)="reset(filter)">
                                </jhi-column-filter-radio>
                                <jhi-column-filter-boolean *ngIf="filter.type === FILTER_TYPES.BOOLEAN"
                                                           [filter]="filter"
                                                           (onApply)="updateBooleanFilter(filter, filter.key)"
                                                           (onReset)="reset(filter)">
                                </jhi-column-filter-boolean>
                                <jhi-column-filter-list *ngIf="filter.type === FILTER_TYPES.LIST"
                                                        [filter]="filter"
                                                        (onApply)="updateListFilter(filter)"
                                                        (onReset)="reset(filter)">
                                </jhi-column-filter-list>
                                <jhi-column-filter-text-with-match-options *ngIf="filter.type === FILTER_TYPES.TEXT_WITH_MATCH_OPTIONS"
                                                                           [filter]="filter"
                                                                           (onApply)="updateTextWithMatchFilter(filter)"
                                                                           (onReset)="reset(filter)">
                                </jhi-column-filter-text-with-match-options>
                                <jhi-column-filter-pedigree-options *ngIf="filter.type === FILTER_TYPES.PEDIGREE_OPTIONS"
                                                                    [filter]="filter"
                                                                    (onApply)="updateFilter(filter)"
                                                                    (onReset)="reset(filter)">

                                </jhi-column-filter-pedigree-options>
                                <jhi-column-filter-attributes *ngIf="filter.type === FILTER_TYPES.ATTRIBUTES"
                                                              [filter]="filter"
                                                              (onApply)="updateFilter(filter)"
                                                              (onReset)="reset(filter)" (onAdd)="addAttributesColumn($event)" (onDelete)="removeAttributesColumn($event)">
                                </jhi-column-filter-attributes>
                                <jhi-column-filter-lot-attributes *ngIf="filter.type === FILTER_TYPES.LOT_ATTRIBUTES"
                                                              [filter]="filter"
                                                              (onApply)="updateFilter(filter)"
                                                              (onReset)="reset(filter)" (onAdd)="addAttributesColumn($event)" (onDelete)="removeAttributesColumn($event)">
                                </jhi-column-filter-lot-attributes>
                                <jhi-column-filter-name-types *ngIf="filter.type === FILTER_TYPES.NAME_TYPES"
                                                              [filter]="filter"
                                                              (onApply)="updateFilter(filter)"
                                                              (onReset)="reset(filter)" (onAdd)="addNameTypeColumn($event)" (onDelete)="removeNameTypeColumn($event)">
                                </jhi-column-filter-name-types>
                                <jhi-column-filter-dropdown *ngIf="filter.type === FILTER_TYPES.DROPDOWN"
                                                            [filter]="filter"
                                                            (onApply)="updateFilter(filter)"
                                                            (onReset)="reset(filter)">
                                </jhi-column-filter-dropdown>
                                <jhi-column-filter-variables *ngIf="filter.type === FILTER_TYPES.VARIABLES"
                                                             [filter]="filter"
                                                             (onApply)="updateFilter(filter)"
                                                             (onReset)="reset(filter)">
                                </jhi-column-filter-variables>
								<jhi-column-filter-properties *ngIf="filter.type === FILTER_TYPES.PROPERTIES"
															 [filter]="filter"
															 (onApply)="updateFilter(filter)"
															 (onReset)="reset(filter)">
								</jhi-column-filter-properties>
								<jhi-column-filter-methods *ngIf="filter.type === FILTER_TYPES.METHODS"
															  [filter]="filter"
															  (onApply)="updateFilter(filter)"
															  (onReset)="reset(filter)">
								</jhi-column-filter-methods>
								<jhi-column-filter-scales *ngIf="filter.type === FILTER_TYPES.SCALES"
															  [filter]="filter"
															  (onApply)="updateFilter(filter)"
															  (onReset)="reset(filter)">
								</jhi-column-filter-scales>
                                <!-- TODO dynamic custom popover filter -->
                            </ng-template>
                            <button *ngIf="filter.type !== FILTER_TYPES.MODAL"
                                    type="button" class="btn rounded-pill"
                                    [ngClass]="{ 'btn-outline-success': filter.hasAppliedValue, 'btn-outline-secondary': !filter.hasAppliedValue }"
                                    [ngbPopover]="popover"
                                    [placement]="['bottom', 'right', 'auto']"
                                    [autoClose]="'outside'"
                                    #popoverButton="ngbPopover">
                                <span [ngbTooltip]="filter.label" [openDelay]="800">{{filter.label}}</span>
                                <i class="fa fa-times-circle ms-2" (click)="clear(filter)" *ngIf="!filter.default"></i>
                            </button>
                            <button *ngIf="filter.type === FILTER_TYPES.MODAL"
                                    type="button" class="btn rounded-pill" (click)="openModal(filter)"
                                    [ngClass]="{ 'btn-outline-success': filter.hasAppliedValue, 'btn-outline-secondary': !filter.hasAppliedValue }">
                                <span [ngbTooltip]="filter.label" [openDelay]="800">{{filter.label}}</span>
                                <i class="fa fa-times-circle ms-2" (click)="clear(filter)" *ngIf="!filter.default" style=""></i>
                            </button>
                        </div>
                    </div>
                    <button class="btn btn-outline-danger ms-2" style="float: left"
                            [ngbTooltip]="'column-filter.clear.filter.tooltip' | translate"
                            [openDelay]="800"
                            (click)="clearAll()" *ngIf="hasClearableFilters()">
                        <i class="fa fa-close"></i>
                    </button>
                    <button class="btn btn-outline-info ms-2" style="float: left" (click)="resetAll($event)"><i class="fa fa-filter-circle-xmark me-1"></i><span jhiTranslate="common.reset.filters"></span></button>
                </div>
            </div>
        </div>

    </div>
</div>
